import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { PostDetailReportedUserInfo } from '../modal';

export default function reducer(state: PostDetailReportedUserInfo = new PostDetailReportedUserInfo(),
  action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.POST_DETAIL_REPORTED_USER_INFO_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.POST_DETAIL_REPORTED_USER_INFO_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.POST_DETAIL_REPORTED_USER_INFO_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
